import { Loader } from '@seddi/three';
import log from 'loglevel';

import { FileCache } from './fileCache';

export class ImageBitmapLoader extends Loader<ImageBitmap> {
  readonly isImageBitmapLoader = true;
  fetchOptions: any;
  options: any;

  constructor(manager) {
    super(manager);

    if (typeof createImageBitmap === 'undefined') {
      log.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
    }

    if (typeof fetch === 'undefined') {
      log.warn('THREE.ImageBitmapLoader: fetch() not supported.');
    }

    this.fetchOptions = { priority: 'high' };
    this.options = { premultiplyAlpha: 'none' };
  }

  setFetchOptions(options) {
    this.fetchOptions = options;
    return this;
  }

  setOptions(options) {
    this.options = options;
    return this;
  }

  load(url, onLoad, onProgress, onError) {
    if (url === undefined) url = '';

    if (this.path !== undefined) url = this.path + url;

    url = this.manager.resolveURL(url);

    const scope = this;

    const cached = FileCache.get(url);

    if (cached !== undefined) {
      scope.manager.itemStart(url);

      setTimeout(function () {
        if (onLoad) onLoad(cached);

        scope.manager.itemEnd(url);
      }, 0);

      return cached;
    }

    const fetchOptions = this.fetchOptions;
    fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
    fetchOptions.headers = this.requestHeader;

    fetch(url, fetchOptions)
      .then(function (res) {
        return res.blob();
      })
      .then(function (blob) {
        return createImageBitmap(blob, Object.assign(scope.options, { colorSpaceConversion: 'none' }));
      })
      .then(function (imageBitmap) {
        FileCache.add(url, imageBitmap);

        if (onLoad) onLoad(imageBitmap);

        scope.manager.itemEnd(url);
      })
      .catch(function (e) {
        if (onError) onError(e);

        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      });

    scope.manager.itemStart(url);
  }
}
